module.exports = __webpack_public_path__ + "static/media/FounderLiz.52497335.png";